(function () {
  'use strict';

  var root = document.querySelector('[data-verify-root]');
  if (!root) return;

  var loading = root.querySelector('[data-verify-loading]');
  var errorBox = root.querySelector('[data-verify-error]');
  var errorText = root.querySelector('[data-verify-error-text]');
  var result = root.querySelector('[data-verify-result]');
  var serialEl = root.querySelector('[data-verify-serial]');
  var totalEl = root.querySelector('[data-verify-total]');
  var designEl = root.querySelector('[data-verify-design]');
  var claimedBox = root.querySelector('[data-verify-claimed]');
  var claimedDateEl = root.querySelector('[data-verify-claimed-date]');
  var claimableBox = root.querySelector('[data-verify-claimable]');
  var loginLink = root.querySelector('[data-verify-login]');
  var claimBtn = root.querySelector('[data-verify-claim]');
  var messageEl = root.querySelector('[data-verify-message]');

  var params = new URLSearchParams(window.location.search);
  var token = params.get('token');
  var loggedIn = root.getAttribute('data-logged-in') === '1';

  function setMessage(text, tone) {
    messageEl.textContent = text || '';
    messageEl.style.color = tone === 'error' ? '#c0392b' : '#1e7e34';
    messageEl.style.display = text ? 'block' : 'none';
  }

  function fail(message) {
    loading.style.display = 'none';
    errorBox.style.display = 'block';
    errorText.textContent = message || 'This code could not be verified.';
  }

  function showClaim() {
    claimableBox.style.display = 'block';
    claimBtn.style.display = loggedIn ? 'inline-block' : 'none';
    loginLink.style.display = loggedIn ? 'none' : 'inline-block';
    if (loggedIn) {
      loginLink.href = '/account/login?return_to=' +
        encodeURIComponent(window.location.pathname + window.location.search);
    }
  }

  function renderClaimed(claimedAt) {
    claimedBox.style.display = 'block';
    if (claimedAt) {
      var d = new Date(claimedAt);
      if (!isNaN(d.getTime())) {
        claimedDateEl.textContent = 'on ' + d.toLocaleDateString(undefined, {
          year: 'numeric', month: 'long', day: 'numeric'
        });
      }
    }
  }

  if (!token) {
    fail();
    return;
  }

  var endpoint = '/apps/pe/verify?token=' + encodeURIComponent(token);

  fetch(endpoint, { headers: { 'Accept': 'application/json' } })
    .then(function (r) {
      if (r.status === 404) throw new Error('not-found');
      if (!r.ok) throw new Error('request-failed');
      return r.json();
    })
    .then(function (data) {
      loading.style.display = 'none';
      if (!data || !data.authentic) { fail(); return; }

      result.style.display = 'block';
      serialEl.textContent = data.serial;
      totalEl.textContent = data.serialTotal;
      designEl.textContent = data.design || '';
      if (designEl.textContent) designEl.style.display = 'block';

      if (data.status === 'claimed') {
        renderClaimed(data.claimedAt);
      } else {
        showClaim();
      }
    })
    .catch(function (err) {
      if (err && err.message === 'not-found') fail();
      else fail('Something went wrong. Please try again.');
    });

  function claim() {
    claimBtn.disabled = true;
    claimBtn.textContent = 'Claiming...';
    setMessage('');

    fetch('/apps/pe/verify/claim?token=' + encodeURIComponent(token), {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: '{}'
    })
      .then(function (r) {
        if (r.status === 409) throw new Error('already-claimed');
        if (r.status === 401) throw new Error('not-authenticated');
        if (!r.ok) throw new Error('request-failed');
        return r.json();
      })
      .then(function () {
        claimedBox.style.display = 'block';
        claimableBox.style.display = 'none';
        claimedDateEl.textContent = '';
        setMessage('Claimed! This serial now belongs to your account.', 'ok');
      })
      .catch(function (err) {
        claimBtn.disabled = false;
        claimBtn.textContent = 'Claim this shirt';
        if (err && err.message === 'already-claimed') {
          claimedBox.style.display = 'block';
          claimableBox.style.display = 'none';
          setMessage('Already claimed by its owner.', 'error');
        } else if (err && err.message === 'not-authenticated') {
          window.location.href = '/account/login?return_to=' +
            encodeURIComponent(window.location.pathname + window.location.search);
        } else {
          setMessage('Something went wrong. Please try again.', 'error');
        }
      });
  }

  if (claimBtn) claimBtn.addEventListener('click', claim);
})();
